import { Component, OnInit } from '@angular/core';
import { ProductInputComponent } from './product-input/product-input.component';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { EditorService } from '../services/editor.service';

@Component({
  selector: 'kve-product-editor',
  templateUrl: './product-editor.component.html',
  styleUrls: ['./product-editor.component.scss']
})
export class ProductEditorComponent implements OnInit {
  
  inputComponent = new DynamicInputComponent(ProductInputComponent);
  menuGroups:any;
  title = "Editing Product Route";
  menuTag = "editProductPageRouteMenu";
  menuGroup:MenuGroup = {
    title:"Editing Product Page Route",
    menuTag:"editProductPageRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:'Settings'
    },
    {
      title:'Sections'
    },
    {
      title:'Add Section',
    },
    {
      title:'Remove Section'
    },
    {
      title:'Order Sections'
    }
  ]
  previousMenu:NbMenuItem[] = [];
  constructor(private editorService:EditorService,
    private menuService:NbMenuService) { }

  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.setMenu(selectedItem);
      }
    })
  }

  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }

}
